// src/js/config/dom.js

// Ett objekt som kommer att hålla alla våra cachade DOM-element.
// Vi exporterar det så att andra moduler kan komma åt elementen.
export const DOMElements = {};

/**
 * Hämtar alla nödvändiga DOM-element och sparar dem i DOMElements-objektet.
 * Denna funktion ska anropas en gång när en sida som behöver den laddas.
 */
export function initializeDOMElements() {
    
    // Config & Order Pages
	DOMElements.configPage = document.getElementById('config-page');
	DOMElements.orderPage = document.getElementById('order-page');

    // Shared Elements
    DOMElements.notificationMessage = document.getElementById('notificationMessage');
    DOMElements.selectConfig = document.getElementById('select-config');
	DOMElements.configFileUpload = document.getElementById('config-file-upload');
    DOMElements.fileNameDisplay = document.getElementById('fileNameDisplay');
    DOMElements.selectCard = document.getElementById("select-block");
    DOMElements.uploadCard = document.getElementById("upload-block");
    DOMElements.orderConfigSourceRadios = document.querySelectorAll("input[name='order-config-source']");
    DOMElements.displayConfiguration = document.getElementById('displayConfiguration');

    // Config Page Specific
    DOMElements.configNameInput = document.getElementById('configName');
    DOMElements.pricingTable = document.querySelector('.configuration-table');
    DOMElements.pricingTableRows = DOMElements.pricingTable ? DOMElements.pricingTable.querySelectorAll('tbody tr') : [];
    DOMElements.adjustNumberBtns = document.querySelectorAll('.adjust-number-btn');
    DOMElements.applyTierBtns = document.querySelectorAll('.apply-tier-btn');
    DOMElements.resetSelectionHeader = document.getElementById('resetSelectionHeader');
    DOMElements.saveToBrowserBtn = document.getElementById('saveToBrowserBtn');
    DOMElements.saveToFileBtn = document.getElementById('saveToFileBtn');
    DOMElements.proceedToOrderBtn = document.getElementById('proceedToOrderBtn');
    DOMElements.openConfigBtn = document.getElementById('openConfigBtn');
    DOMElements.deleteConfigBtn = document.getElementById('deleteConfigBtn');
    
    // Order Page Specific
    DOMElements.sendOrderBtn = document.getElementById('sendOrderBtn');
    DOMElements.showBtn = document.getElementById('showBtn');
    DOMElements.showConfigurationTable = document.getElementById('show-configuration-table');
    DOMElements.output = document.getElementById('output');
    DOMElements.orderSummaryTable = document.getElementById('orderSummaryTable');
    DOMElements.displayCheapestTier = document.getElementById('displayCheapestTier');
    DOMElements.displayPackagePrice = document.getElementById('displayPackagePrice');
    DOMElements.displayAddonPrice = document.getElementById('displayAddonPrice');
    DOMElements.displayTotalPrice = document.getElementById('displayTotalPrice');
    DOMElements.displaySummaryPricesSection = document.getElementById('displaySummaryPricesSection');
    DOMElements.displaySummaryPricesNotAvailable = document.getElementById('displaySummaryPricesNotAvailable');
    DOMElements.selectedConfigDisplay = document.getElementById('selectedConfigDisplay');
    DOMElements.selectedConfigDisplayNotValid = document.getElementById('selectedConfigDisplayNotValid');

    // Formulärfält för order
    DOMElements.company = document.getElementById('company');
    DOMElements.corpId = document.getElementById('corpId');
    DOMElements.address = document.getElementById('address');
    DOMElements.zipCode = document.getElementById('zipCode');
    DOMElements.city = document.getElementById('city');
    DOMElements.name = document.getElementById('name');
    DOMElements.customerEmail = document.getElementById('customerEmail');
    DOMElements.phoneNo = document.getElementById('phoneNo');
    DOMElements.invoiceEmail = document.getElementById('invoiceEmail');
    DOMElements.poNumber = document.getElementById('poNumber');
    DOMElements.invoiceReference = document.getElementById('invoiceReference');
    DOMElements.termsCheckbox = document.getElementById('terms-checkbox');

    // Load Config Modal
    DOMElements.loadConfigModal = document.getElementById('load-config-modal');
    DOMElements.loadConfigBtn = document.getElementById('loadConfigBtn');

    // Confirm Save Modal
    DOMElements.confirmSaveModal = document.getElementById('confirmSaveModal');
    DOMElements.confirmSaveMessage = document.getElementById('confirmSaveMessage');
    DOMElements.confirmOverwriteBtn = document.getElementById('confirmOverwriteBtn');
    DOMElements.confirmRenameBtn = document.getElementById('confirmRenameBtn');
    DOMElements.confirmCancelBtn = document.getElementById('confirmCancelBtn');

    // Prompt Delete Modal
    DOMElements.promptDeleteModal = document.getElementById('promptDeleteModal');
    DOMElements.promptDeleteMessage = document.getElementById('promptDeleteMessage');
    DOMElements.promptDeleteDeleteBtn = document.getElementById('promptDeleteDeleteBtn');
    DOMElements.promptDeleteCancelBtn = document.getElementById('promptDeleteCancelBtn');
    
    // Prompt For Name Modal
    DOMElements.promptNameModal = document.getElementById('promptNameModal');
    DOMElements.promptNameMessage = document.getElementById('promptNameMessage');
    DOMElements.promptErrorMessage = document.getElementById('promptErrorMessage');
    DOMElements.promptNameInput = document.getElementById('promptNameInput');
    DOMElements.promptNameConfirmBtn = document.getElementById('promptNameConfirmBtn');
    DOMElements.promptNameCancelBtn = document.getElementById('promptNameCancelBtn');
        
    console.log('DOM Elements initialized and cached.');
}